import React from 'react';
import { Link } from 'react-router-dom';

function GeneralTextBlock({
  title,
  subtitle,
  paraOne,
  paraTwo,
  paraThree,
  mainImageUrl,
  imageAlt,
  imageAria,
  ctaLink,
  ctaText,
  ctaAria,
}) {
  return (
    <section className='grid w-full'>
      <div className='grid w-full px-6 md:container md:mx-auto items-center lg:min-h-[80vh]'>
        <article className='grid lg:grid-cols-[2fr_1fr] gap-6 sm:gap-12 lg:gap-x-16'>
          {/* Text */}
          <section className='grid w-full items-center'>
            <div className='grid gap-8 sm:gap-10 w-full h-fit'>
              <div className='grid gap-2'>
                <div>
                  <h2 className='text-4xl lg:text-5xl font-titleFont'>{title}</h2>
                </div>
                <div>
                  <h3 className='text-xl lg:text-2xl uppercase text-colour6'>
                    {subtitle}
                  </h3>
                </div>
              </div>
              <div className='text-md font-extralight tracking-wider grid gap-y-4 text-colour2'>
                {paraOne && (
                  <div>
                    <p>{paraOne}</p>
                  </div>
                )}
                {paraTwo && (
                  <div>
                    <p>{paraTwo}</p>
                  </div>
                )}
                {paraThree && (
                  <div>
                    <p>{paraThree}</p>
                  </div>
                )}
              </div>

              {/* cta */}
              {ctaLink && (
                <section className='grid'>
                  <div className='grid w-fit mx-auto lg:mx-0'>
                    <Link
                      to={ctaLink}
                      className='bg-colour6 grid hover:brightness-110 active:bg-colour6 w-full border-2 border-solid border-colour2 py-2 text-center text-colour1 font-serif px-12 uppercase'
                      aria-label={ctaAria}
                      title={ctaText}
                    >
                      {ctaText}
                    </Link>
                  </div>
                </section>
              )}
            </div>
          </section>

          {/* Image */}
          <section className='grid w-full items-center'>
            <div className='relative'>
              <img
                src={mainImageUrl}
                alt={imageAlt}
                aria-label={imageAria}
                className='mx-auto max-h-[60vh]'
              />
            </div>
          </section>
        </article>
      </div>
    </section>
  );
}

export default GeneralTextBlock;
